import { render, staticRenderFns } from "./OpenEmail.vue?vue&type=template&id=27e3c1d6"
import script from "./OpenEmail.vue?vue&type=script&lang=js"
export * from "./OpenEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports